import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Container, Row } from 'reactstrap';
import Logo from '../../assets/svg/logo-blue.svg';


class ReferenceConfirmed extends Component {
    render() {
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{maxWidth: '100px'}} src={Logo} alt="PolyRents"/>
                </div>


                <Container>
                    <Row>
                        <h1>Reference confirmed!</h1>
                    </Row>
                    <hr/>
                    <p>
                        Wasn't that easy? PolyRents is on a mission to simplify the housing rental process for everyone (including you!). We'd love to help you manage the applications for your property as well.
                    </p>

                    <p>
                        <strong>PolyRents is a free bolt-on to the front of your existing tenant screening pipeline</strong> that helps you manage the influx of rental applications you receive for a property. PolyRents provides you with the data you need to no longer spend time on unqualified applicants.
                        All you need to do is send potential applicants a link to your listing so they can submit their information and apply online. When they do, you'll get an email.
                    </p>
                    <p><strong>PolyRents provides you all of the information you need to make a decision on a group of tenants:</strong></p>
                    <ul>
                        <li>Full digital rental applications</li>
                        <li>Credit reports and background checks provided by TransUnion (the one that didn't get hacked)</li>
                        <li>Rental references</li>
                        <li>Guarantor information</li>
                        <li><strong>Historical Noise Violation and police incident data</strong> (in San Luis Obispo)</li>
                    </ul>
                    <div className="center">
                        <Button color="success" tag={Link} to="/register/">Start Screening your Tenants</Button>
                    </div>
                    <hr/>
                    <Row>
                        <p>
                            <small>On the fence? Get in touch with our CEO Alex by emailing him at alex@polyrents.com. He'd love to see what your needs are and set up a demo.</small>
                        </p>
                        {/* <p>
                            <small>
                                P.S. That's his personal cell. He had us put that on here (even though we told him not to) because he wants to talk to everyone about PolyRents (whether you decide to sign up or not).
                            </small>
                        </p> */}
                    </Row>
                </Container>
            </div>
        );
    }
}

export default ReferenceConfirmed;



// WEBPACK FOOTER //
// ./src/containers/reference/ReferenceConfirmed.js